export default function VmDivider({className = ''}) {
  return <div className={'bg-gray-200 p-vm-0.5 ' + className} />
}
